package fr.frux.feature.map

import fr.frux.core.maps.LocationPermissionController
import fr.frux.core.maps.LocationPermissionStatus

/**
 * Geste « me localiser », partage entre l'ecran carte et la visee d'un arbre : leve la suppression
 * venue de l'accueil (#502) avant toute branche, puis agit selon l'etat de la permission.
 */
internal fun onLocateRequested(
    viewModel: MapViewModel,
    permission: LocationPermissionController,
) {
    // Les deux branches qui re-signalent un refus sans passer par
    // onLocateRequestedPendingPermission resteraient muettes sans cette levee.
    viewModel.onLocateTapped()
    when (permission.status) {
        LocationPermissionStatus.GRANTED -> {
            viewModel.refreshLocation()
        }

        // Redemander n'afficherait plus rien : on reaffiche le bandeau « reglages ».
        LocationPermissionStatus.PERMANENTLY_DENIED -> {
            viewModel.onPermissionResult(LocationPermissionStatus.PERMANENTLY_DENIED)
        }

        // Android recommande d'expliquer avant de redemander : le bandeau porte l'explication et
        // son bouton « Autoriser ».
        LocationPermissionStatus.DENIED -> {
            if (permission.shouldExplain) {
                viewModel.onPermissionResult(LocationPermissionStatus.DENIED)
            } else {
                viewModel.onLocateRequestedPendingPermission()
                permission.request()
            }
        }

        // L'accord qui suit doit localiser sans second clic, meme si une vue memorisee prime au
        // lancement.
        LocationPermissionStatus.NOT_REQUESTED -> {
            viewModel.onLocateRequestedPendingPermission()
            permission.request()
        }
    }
}
